import * as React from 'react';
import {
  motion,
  useViewportScroll,
} from 'framer-motion';

import {
  Breakpoint,

  useDimensions,
} from '@bluecurrent/web-component-lib';

export default function Background({
  height,
}) {
  const size = useDimensions();
  const { scrollYProgress } = useViewportScroll();

  const [y, setY] = React.useState(0);

  React.useEffect(() => {
    scrollYProgress.onChange((value) => setY(value));
  }, [scrollYProgress]);

  return size.width >= Breakpoint.md && (
    <>
      <div
        style={{
          height,
          position: 'absolute',
          width: '45%',
          right: 0,
          bottom: 0,
        }}
      >
        <motion.div
          style={{
            position: 'absolute',
            height: '100%',
            width: 500,
            backgroundImage: 'url(https://cdn.sanity.io/images/pnajo2cq/production/db8efb2d8153a8a678cff10045e66fc980442e90-1000x500.png)',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            zIndex: 1,
            bottom: -100,
            left: y * 1000,
            opacity: 0.8,
          }}
        />
        <motion.div
          style={{
            position: 'absolute',
            height: 300,
            width: 500,
            backgroundImage: 'url(https://cdn.sanity.io/images/pnajo2cq/production/c1b8a64e9daf95f0eba8ab36a560b5f04a4ea12a-1000x500.png)',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            zIndex: 1,
            right: y * 1000,
            bottom: 250,
            opacity: 0.8,
          }}
        />
      </div>
      <div
        style={{
          height: '100%',
          width: size.width < Breakpoint.md ? '100%' : '54.5%',
          position: 'absolute',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundImage: 'url("https://cdn.sanity.io/images/pnajo2cq/production/8f3d1fcd449fedc8cf8bc5cd66bcce78a73449b5-1000x800.jpg")',
          opacity: 0.7,
          zIndex: 0,
          right: 0,
          top: 0,
          bottom: 0,
        }}
      />
    </>
  );
}
